"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../lib/helpers");
/* This allows us to paint over the status bar on iOS notch that otherwise is very hard to style. */
const StatusBarNotch = () => {
    if (!helpers_1.hasNotch() || !helpers_1.isIOSDevice()) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "j-status-bar-notch" }));
};
exports.default = StatusBarNotch;
